import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row q-pa-md border-bottom" }
const _hoisted_2 = { class: "col-6 text-body2" }
const _hoisted_3 = { class: "row q-pa-md border-bottom" }
const _hoisted_4 = { class: "col-6 text-body2" }
const _hoisted_5 = { class: "row q-pa-md border-bottom" }
const _hoisted_6 = { class: "col-6 text-body2" }
const _hoisted_7 = { class: "row q-pa-md border-bottom" }
const _hoisted_8 = { class: "col-6 text-body2" }
const _hoisted_9 = { class: "row q-pa-md border-bottom" }
const _hoisted_10 = { class: "col-6 text-body2" }
const _hoisted_11 = { class: "row q-pa-md border-bottom" }
const _hoisted_12 = { class: "col-6 text-body2" }
const _hoisted_13 = { class: "row q-pa-md border-bottom" }
const _hoisted_14 = { class: "col-6 text-body2" }
const _hoisted_15 = { class: "row q-pa-md border-bottom" }
const _hoisted_16 = { class: "col-6 text-body2" }
const _hoisted_17 = { class: "row q-pa-md border-bottom" }
const _hoisted_18 = { class: "col-6 text-subtitle2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "col-6 text-body2" }
const _hoisted_21 = { class: "row q-pa-md border-bottom" }
const _hoisted_22 = { class: "col-6 text-body2" }
const _hoisted_23 = { class: "row q-pa-md border-bottom" }
const _hoisted_24 = { class: "col-6 text-body2" }
const _hoisted_25 = {
  key: 0,
  class: "row q-pa-md border-bottom"
}
const _hoisted_26 = { class: "col-6 text-body2" }
const _hoisted_27 = {
  key: 1,
  class: "row q-pa-md border-bottom"
}
const _hoisted_28 = { class: "row q-pa-md border-bottom" }
const _hoisted_29 = { class: "col-6 text-body2" }
const _hoisted_30 = { class: "row q-pa-md border-bottom" }
const _hoisted_31 = { class: "col-6 text-subtitle2" }
const _hoisted_32 = { class: "col-6 text-body2" }
const _hoisted_33 = {
  key: 2,
  class: "row q-pa-md border-bottom"
}

import { PropType, computed } from "vue";
  import { useCurrencyFormatter } from "src/functions";
  import { PcpPrice, Vehicle, HpPrice } from "src/types/loan-application/index";
  import { StockFilter } from "src/types/vehicle-search/index";
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'StockDetailsFinance',
  props: {
    vehicle: {
      type: Object as PropType<Vehicle>,
      default: null
    },
    priceMatrix: {
      type: Object as PropType<PcpPrice | HpPrice>,
      default: null
    },
    filters: {
      type: Object as PropType<StockFilter>,
      default: null
    }
  },
  setup(__props) {

  const props = __props

  const isCapPCPResidual = computed(() => {
    return [67,73].includes(props.priceMatrix?.financeCompanyId) && props.priceMatrix?.isPCP
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Vehicle Price ", -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.vehicle ? _unref(useCurrencyFormatter)(__props.vehicle.price) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Deposit ", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.depositDisplay) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Part Ex. Equity ", -1)),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.filters ? _unref(useCurrencyFormatter)(__props.priceMatrix.pxValue ?? 0) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Settlement ", -1)),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.filters ? _unref(useCurrencyFormatter)(__props.priceMatrix.pxSettlement ?? 0) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Balance to Finance ", -1)),
      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.amountToFinance ?? 0) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Term ", -1)),
      _createElementVNode("div", _hoisted_12, _toDisplayString(__props.priceMatrix ? __props.priceMatrix.term : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Lender ", -1)),
      _createElementVNode("div", _hoisted_14, _toDisplayString(__props.priceMatrix ? __props.priceMatrix.financeCompany : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " APR ", -1)),
      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.priceMatrix ? __props.priceMatrix.effectiveRate + '%' + (__props.priceMatrix.flatRate ? ' (Effective)' : '') : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        (__props.priceMatrix && __props.priceMatrix.isPCP)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Optional "))
          : _createCommentVNode("", true),
        _cache[8] || (_cache[8] = _createTextVNode("Final Payment "))
      ]),
      _createElementVNode("div", _hoisted_20, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.finalPayment ?? 0, 2, 2) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_21, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Option-to-Purchase Fee ", -1)),
      _createElementVNode("div", _hoisted_22, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.lendersPostFees ?? 0) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_23, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Total Cost of Credit ", -1)),
      _createElementVNode("div", _hoisted_24, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.costOfCredit ?? 0, 2, 2) : '-'), 1)
    ]),
    (__props.priceMatrix && __props.priceMatrix.isPCP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Annual Mileage Limit ", -1)),
          _createElementVNode("div", _hoisted_26, _toDisplayString(__props.filters.annualMileage.toLocaleString()) + " miles ", 1)
        ]))
      : _createCommentVNode("", true),
    (__props.priceMatrix && __props.priceMatrix.isPCP)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[12] || (_cache[12] = [
          _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Excess Mileage Charge ", -1),
          _createElementVNode("div", { class: "col-6 text-body2" }, " 8p/mile ", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-6 text-subtitle2" }, " Total Repayable ", -1)),
      _createElementVNode("div", _hoisted_29, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.totalAmountPayable ?? 0, 2, 2) : '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, _toDisplayString(__props.priceMatrix ? __props.priceMatrix.termDisplay + ' monthly payments of' : 'Monthly payment'), 1),
      _createElementVNode("div", _hoisted_32, _toDisplayString(__props.priceMatrix ? _unref(useCurrencyFormatter)(__props.priceMatrix.monthlyPayment ?? 0, 2, 2) : '-') + _toDisplayString(isCapPCPResidual.value ? '*' : ''), 1)
    ]),
    (isCapPCPResidual.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[14] || (_cache[14] = [
          _createElementVNode("div", { class: "col-12 text-caption" }, " *Price is indicative and may change upon final checks ", -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}
}

})